import * as React from 'react';

class SelectAgGridRenderer extends React.Component{

  render(){
    let selected = null;
    this.props.values.map((val) => {
      if(this.props.value && val.key === this.props.value.key){
        selected = val;
      }
    });
    return(
      <p>{selected && selected.name}</p>
    )
  }
}
export default SelectAgGridRenderer;


// WEBPACK FOOTER //
// ./src/views/Projects/Projects/FieldRenderer/SelectAgGridRenderer.js